import { render, staticRenderFns } from "./display_block.vue?vue&type=template&id=43cf3dd4&scoped=true&"
import script from "./display_block.vue?vue&type=script&lang=js&"
export * from "./display_block.vue?vue&type=script&lang=js&"
import style0 from "./display_block.vue?vue&type=style&index=0&id=43cf3dd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cf3dd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('43cf3dd4', component.options)
    } else {
      api.reload('43cf3dd4', component.options)
    }
    module.hot.accept("./display_block.vue?vue&type=template&id=43cf3dd4&scoped=true&", function () {
      api.rerender('43cf3dd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/display_block.vue"
export default component.exports